import { useContext } from "react";
import { ConfiguratorContext } from "../context";

const usePurchaseTimeframeData = () => {

    const [state, setState] = useContext(ConfiguratorContext);

    //Getters
    const getTimeframeOptions = () => state.purchase_timeframe.options ? state.purchase_timeframe.options : null;
    const getSelectedTimeframe = () => state.purchase_timeframe.selected;
    const setTimeframeOption = (option) => {
        setState(prevState => ({
            ...prevState,
            purchase_timeframe: {
                ...prevState.purchase_timeframe,
                selected: option
            }
        }))
    }

    //Methods

    return {
        getTimeframeOptions,
        getSelectedTimeframe,
        setTimeframeOption
    }

}


export default usePurchaseTimeframeData;
